import PropTypes from 'prop-types';
import React from 'react';
import { truncateWithEllipsis } from '../../../../utilities/ui_utilities';
import { EmitMetric } from '../../../Analytics/VisibilityPixel/VisibilityPixel';
import ResponsiveVideo from '../../../Elements/ResponsiveVideo/ResponsiveVideo';
import { buildImagePath } from '../../../JobComponents/Company/Image/logo';

import './AdLayout.scss';

export default class AdLayout extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        /**
         * media info
         */
        media: PropTypes.shape({
            type: PropTypes.oneOf(['video', 'image']),
            src: PropTypes.string,
        }).isRequired,
        /**
         * company info
         */
        company: PropTypes.shape({
            url: PropTypes.string,
            logo: PropTypes.shape({
                src: PropTypes.string,
                alt: PropTypes.string,
            }),
            id: PropTypes.number,
        }).isRequired,
        /**
         * title for card
         */
        title: PropTypes.string.isRequired,
        /**
         * description for card
         */
        description: PropTypes.string.isRequired,
        emitMetric: PropTypes.bool,
    };

    static defaultProps = {
        emitMetric: false,
    };

    renderMedia = (injectedTransforms) => {
        if (this.props.media) {
            return this.props.media.type === 'image' ? (
                <img
                    className={`featured-visual ${this.props.media.type}-visual`}
                    src={buildImagePath(
                        this.props.media.src,
                        'default',
                        injectedTransforms
                    )}
                />
            ) : (
                <div className={`featured-visual video-container`}>
                    <ResponsiveVideo
                        cloudinaryID={this.props.media.src}
                        emitMetric={this.props.emitMetric}
                    />
                </div>
            );
        }
    };

    openInTab = async () => {
        if (window) {
            EmitMetric({
                company_id: [this.props.company.id],
                misc_event_type: 'homepage-company-ad-click',
                misc_event_count: 1,
            });
            let win = window.open(this.props.company.url, '_blank');
            win.focus();
        }
    };

    render() {
        const injectedTransforms = {
            default: 'c_scale,f_auto,q_auto,w_320',
            companyLogo: 'c_lpad,f_auto,q_auto,w_120,h_50',
        };
        return (
            <div
                className="component-Homepage-FeaturedCompanyCards-AdLayout"
                onClick={this.openInTab}
            >
                <div className="images">
                    {this.renderMedia(injectedTransforms)}
                    <div className="company-logo">
                        <img
                            className="company-logo-img"
                            src={buildImagePath(
                                this.props.company.logo.src,
                                'companyLogo',
                                injectedTransforms
                            )}
                            alt={this.props.company.logo.alt}
                        />
                    </div>
                </div>
                <div className="job-text">
                    <div className="job-title">
                        {truncateWithEllipsis(this.props.title, 60)}
                    </div>
                    <div className="job-description">
                        {truncateWithEllipsis(this.props.description, 295)}
                    </div>
                </div>
            </div>
        );
    }
}
